export const ITEMS_LIST = 'ITEMS_LIST';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const INCRESE_PRODUCT = 'INCRESE_PRODUCT';
export const SET_FILTERD_LIST = 'SET_FILTERD_LIST';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';